import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { CompanyResponsibleType } from 'enums/CompanyResponsibleType';
import { CredentialType } from 'enums/CredentialType';
import { UserModel } from 'models/generated/Identity.Api.Models.User';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyDataProvider, CompanyDataProviderFactory } from 'services/company-data-provider';
import { CompanyService } from 'services/company.service';
import { CredentialService } from 'services/credential.service';
import { UrlParam } from 'services/navigation.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'company-responsible',
	templateUrl: './company-responsible.component.html',
	imports: [Layout, CustomSelectComponent, NgClass, TranslatePipe]
})
export class CompanyResponsibleComponent {

	private dataProvider?: CompanyDataProvider;

	userList: SelectListItemModel[] = [];
	companyResponsibles = new Map<CompanyResponsibleType, string | undefined>();
	companyResponsibleTypeEnum = CompanyResponsibleType;
	responsibleTypes: CompanyResponsibleType[] = [];
	editResponsible?: boolean;

	private _companyId = '';
	@UrlParam
	@Input()
	set companyId(id: string) {
		this._companyId = id;
		if (id != null && id !== '') {
			this.dataProvider = this.dataProviderFactory.getProviderForCompanyId(id);
			this.dataProvider.getCompanyResponsibles()
				.then(companyResponsibles => {
					this.responsibleTypes = Array.from(CompanyResponsibleType.getKeys().keys());
					CompanyResponsibleType.getKeys().forEach((value, key) => {
						const responsible = companyResponsibles.find(cr => cr.role === key);
						this.companyResponsibles.set(key, responsible?.userId);
					});
				});
		}
	}
	get companyId() {
		return this._companyId;
	}

	constructor(
		private readonly dataProviderFactory: CompanyDataProviderFactory,
		private readonly companyService: CompanyService,
		private readonly credentialService: CredentialService,
		private readonly userService: UserService,
		public sanitizer: DomSanitizer
	) {

		this.userList = userService.getUserSelectList();
		this.editResponsible = this.credentialService.hasCredentials(CredentialType.BetaUserAccess);
	}

	responsibleUser(role: CompanyResponsibleType): UserModel | null {
		const userId = this.companyResponsibles.get(role);
		return this.userService.user(userId);
	}

	updateCompanyResponsible(responsibleType: CompanyResponsibleType, userId: string) {
		if (!userId) {
			this.companyService.removeCompanyResponsible(this.companyId, responsibleType).then(() => {
				this.companyResponsibles.set(responsibleType, undefined);
			});
		} else {
			this.companyService.updateCompanyResponsible(this.companyId, responsibleType, userId).then(() => {
				this.companyResponsibles.set(responsibleType, userId);
			});
		}
	}
}
